import React from 'react';

import { AnomalySectionProps } from './index';
import { EventTimelineSection } from './eventTimelineSection';

// The drop event marker cannot be disabled (see DeviceEventsTimelineChart's lockedEvents prop),
// so it is both the only initially-enabled event here and the one locked event. Drop events are
// Android-only - see useAnomalyExaminationEventFilters/getInitialEventFilters, which strips
// deviceDropped from the filter state entirely for a non-Android device.
const INITIALLY_ENABLED_EVENTS = ['deviceDropped'] as const;
const LOCKED_EVENTS = ['deviceDropped'] as const;

export function DropsSection(props: AnomalySectionProps) {
  return (
    <EventTimelineSection
      {...props}
      initiallyEnabledEvents={INITIALLY_ENABLED_EVENTS}
      lockedEvents={LOCKED_EVENTS}
      cypressId="deviceAnomalyExaminationDropsTimeline"
    />
  );
}
